<div class="page">
  <div class="page__container">
    <h1 class="page__title h2 mb-5">{{ 'sender_alphanumeric' | translate }}</h1>

    <div class="dashboard-toastr-container">
      <div class="toastr-relative toastr-sm toastr-no-shadow my-4" toastContainer></div>
    </div>

    <ng-container *ngIf="hasValidatedSendersList">
      <ng-template #modalAddEditAlphaDisabled let-c="close" let-d="dismiss">
        <wsb-modal (primary)="modalDeleteAlphaForm()" (dismiss)="d()" cancelButtonEnable="true"
          title="{{ 'sms_senders_error_alpha_register_title' | translate }}"
          text="{{ 'sms_senders_error_alpha_register_message' | translate }}"></wsb-modal>
      </ng-template>
      <ng-template #modalAddEditAlpha let-c="close" let-d="dismiss">
        <wsb-modal (primary)="modalAddEditAlphaForm()"
          [primaryDisabled]="addAlphaSenderForm.invalid || (IsDestinationIsES && (!customerVatCode || addAlphaSenderForm.get('nifConfirmation').value !== 'confirm'))"
          [primaryButtonEnable]="!senderToEdit" [cancelButtonEnable]="!senderToEdit"
          primaryButtonText="{{ 'senders_new_ok' | translate }}" (dismiss)="d()"
          title="{{ (senderToEdit ? 'common_view' : 'sender_new') | translate }}">
          <div body>
            <div
              class="alert alert-info d-flex align-items-center p-3 mb-4 rounded-3 border-start border-info border shadow-sm">
              <i class="bi bi-info-circle-fill text-info fs-5 me-3"></i>

              <div class="flex-grow-1 text-dark small lh-base">
                <span [innerHTML]="'senders_australia_register_flow' | translate"></span>
              </div>
            </div>
            <form *ngIf="!senderToEdit || senderToEditFull" [formGroup]="addAlphaSenderForm">
              <div class="form-group row">
                <label for="sender" class="col-sm-4" translate>sender_sender</label>
                <div class="col-sm-8">
                  <input type="text" class="form-control" id="sender" formControlName="sender" wsbAppControlValidator
                    [ngbTooltip]="IsDestinationIsES ? ('sender_es_tooltip' | translate) : null"
                    [readonly]="senderToEdit" [fc]="addAlphaSenderForm.get('sender')" />
                  <wsb-validation-error-msg [fc]="addAlphaSenderForm.get('sender')"></wsb-validation-error-msg>
                </div>
              </div>
              <div class="form-group row">
                <label for="sender" class="col-sm-4" translate>sender_destination_nation</label>
                <div class="col-sm-8">
                  <select id="destinationTerritory" formControlName="destinationTerritory" name="destinationTerritory"
                    class="form-control form-select form-select-sm">
                    <option *ngFor="let destinationTerritoryCode of destinationTerritories"
                      [value]="destinationTerritoryCode">
                      <span>{{ displayTerritoryName(destinationTerritoryCode) }}</span>
                    </option>
                  </select>
                  <wsb-validation-error-msg
                    [fc]="addAlphaSenderForm.get('destinationTerritory')"></wsb-validation-error-msg>
                </div>
              </div>
              <div class="form-group row">
                <label for="contactName" class="col-sm-4" translate>sender_new_name</label>
                <div class="col-sm-8">
                  <div class="row">
                    <div class="col-sm-6">
                      <input type="text" class="form-control" id="contactName" formControlName="contactName"
                        wsbAppControlValidator placeholder="{{ 'contact_name' | translate }}" [readonly]="senderToEdit"
                        [fc]="addAlphaSenderForm.get('contactName')" />
                      <wsb-validation-error-msg [fc]="addAlphaSenderForm.get('contactName')"></wsb-validation-error-msg>
                    </div>
                    <div class="col-sm-6">
                      <input type="text" class="form-control" id="contactSurname" formControlName="contactSurname"
                        wsbAppControlValidator placeholder="{{ 'contact_surname' | translate }}"
                        [readonly]="senderToEdit" [fc]="addAlphaSenderForm.get('contactSurname')" />
                      <wsb-validation-error-msg
                        [fc]="addAlphaSenderForm.get('contactSurname')"></wsb-validation-error-msg>
                    </div>
                  </div>
                </div>
              </div>
              <div class="form-group row">
                <label for="companyName" class="col-sm-4" translate>sms_senders_new_company</label>
                <div class="col-sm-8">
                  <input type="text" class="form-control" id="companyName" formControlName="companyName"
                    wsbAppControlValidator [readonly]="senderToEdit" [fc]="addAlphaSenderForm.get('companyName')" />
                  <wsb-validation-error-msg [fc]="addAlphaSenderForm.get('companyName')"></wsb-validation-error-msg>
                </div>
              </div>
              <div class="form-group row" *ngIf="!IsDestinationIsFR">
                <label for="contactAddress" class="col-sm-4" translate>sms_senders_new_address</label>
                <div class="col-sm-8">
                  <div class="row">
                    <div class="col-sm-12">
                      <input type="text" class="form-control" id="contactAddress" formControlName="contactAddress"
                        wsbAppControlValidator placeholder="{{ 'sms_senders_new_address_ph' | translate }}"
                        [readonly]="senderToEdit" [fc]="addAlphaSenderForm.get('contactAddress')" />
                      <wsb-validation-error-msg
                        [fc]="addAlphaSenderForm.get('contactAddress')"></wsb-validation-error-msg>
                    </div>
                  </div>
                  <div class="row">
                    <div class="col-sm-6">
                      <input type="text" class="form-control" id="contactPostalCode" formControlName="contactPostalCode"
                        wsbAppControlValidator placeholder="{{ 'sms_senders_new_postcode_ph' | translate }}"
                        [readonly]="senderToEdit" [fc]="addAlphaSenderForm.get('contactPostalCode')" />
                      <wsb-validation-error-msg
                        [fc]="addAlphaSenderForm.get('contactPostalCode')"></wsb-validation-error-msg>
                    </div>
                    <div class="col-sm-6">
                      <input type="text" class="form-control" id="contactCity" formControlName="contactCity"
                        wsbAppControlValidator placeholder="{{ 'account_city' | translate }}" [readonly]="senderToEdit"
                        [fc]="addAlphaSenderForm.get('contactCity')" />
                      <wsb-validation-error-msg [fc]="addAlphaSenderForm.get('contactCity')"></wsb-validation-error-msg>
                    </div>
                  </div>
                </div>
              </div>
              <div class="form-group row" *ngIf="!IsDestinationIsFR">
                <label for="vatNumber" class="col-sm-4" translate>account_piva</label>
                <div class="col-sm-8">
                  <input type="text" class="form-control" id="vatNumber" formControlName="vatNumber"
                    wsbAppControlValidator [readonly]="senderToEdit" [fc]="addAlphaSenderForm.get('vatNumber')" />
                  <wsb-validation-error-msg [fc]="addAlphaSenderForm.get('vatNumber')"></wsb-validation-error-msg>
                </div>
              </div>
              <div class="form-group row" *ngIf="!IsDestinationIsFR">
                <label for="fiscalCode" class="col-sm-4" translate>account_cf</label>
                <div class="col-sm-8">
                  <input type="text" class="form-control" id="fiscalCode" formControlName="fiscalCode"
                    wsbAppControlValidator [readonly]="senderToEdit" [fc]="addAlphaSenderForm.get('fiscalCode')" />
                  <wsb-validation-error-msg [fc]="addAlphaSenderForm.get('fiscalCode')"></wsb-validation-error-msg>
                </div>
              </div>
              <div class="form-group row" *ngIf="!IsDestinationIsFR">
                <label for="contactInfo" class="col-sm-4" translate>account_pec</label>
                <div class="col-sm-8">
                  <input type="text" class="form-control" id="contactInfo" formControlName="contactInfo"
                    wsbAppControlValidator [readonly]="senderToEdit" [fc]="addAlphaSenderForm.get('contactInfo')" />
                  <wsb-validation-error-msg [fc]="addAlphaSenderForm.get('contactInfo')"></wsb-validation-error-msg>
                </div>
              </div>
              <div class="form-group row" *ngIf="IsDestinationIsIE">
                <label for="sidrId" class="col-sm-4" translate>COMREG SiDrID</label>
                <div class="col-sm-8">
                  <input type="text" class="form-control" id="sidrId" formControlName="sidrId" wsbAppControlValidator
                    [readonly]="senderToEdit" [fc]="addAlphaSenderForm.get('sidrId')" />
                  <wsb-validation-error-msg [fc]="addAlphaSenderForm.get('sidrId')"></wsb-validation-error-msg>
                </div>
              </div>

              <div *ngIf="IsDestinationIsES">
                <div style="margin-bottom: 15px;">
                  <div class="text-info small">
                    <span [innerHTML]="'sender_es_help_cnmc' | translate"></span>
                  </div>
                </div>

                <div class="form-group row">
                  <label class="col-sm-4" translate>NIF Titular</label>
                  <div class="col-sm-8">
                    <input type="text" class="form-control bg-light" formControlName="nifTitular" readonly
                      maxlength="50" />
                  </div>
                </div>

                <div class="form-group row mb-2">
                  <div class="col-sm-8 offset-sm-4">
                    <div class="d-flex align-items-center mb-2">
                      <input class="form-check-input me-2 mt-0" type="radio" id="confirmNif" value="confirm"
                        formControlName="nifConfirmation">
                      <label class="form-check-label mb-0" for="confirmNif" translate>sender_es_nif_confirm</label>
                    </div>
                    <div class="d-flex align-items-center">
                      <input class="form-check-input me-2 mt-0" type="radio" id="changeNif" value="change"
                        formControlName="nifConfirmation">
                      <label class="form-check-label mb-0" for="changeNif" translate>sender_es_nif_change</label>
                    </div>
                  </div>
                </div>

                <div class="form-group row mb-3"
                  *ngIf="!customerVatCode || addAlphaSenderForm.get('nifConfirmation').value === 'change'">
                  <div class="col-sm-8 offset-sm-4">
                    <div class="text-danger small" [innerHTML]="'sender_es_nif_warning' | translate">
                    </div>
                  </div>
                </div>
              </div>



              <div *ngIf="!senderToEdit && !IsDestinationIsFR">
                <div style="margin-bottom: 10px;">
                  <div class="text-info small" [innerHTML]="'sis_service_info' | translate" *ngIf="!IsDestinationIsUK">
                  </div>
                  <div class="text-info small" [innerHTML]="'sis_service_info_short' | translate"
                    *ngIf="IsDestinationIsUK"></div>
                </div>
                <div class="form-group row" *ngIf="addAlphaSenderForm.get('filesUpload')['controls'].length">
                  <label for="contactInfo" class="col-sm-4" translate>common_select</label>
                  <div class="col-sm-8 ">
                    <ul>
                      <li formArrayName="filesUpload"
                        *ngFor="let file of addAlphaSenderForm.get('filesUpload')['controls']; let i = index">
                        <input type="file" id="file" accept=".doc, .docx, .xls, .xlsx, .csv, .pdf, .jpeg, .jpg, .png"
                          class="form-control " #fileInput (change)="onFileUploadChange($event, i)" />
                      </li>
                    </ul>
                    <wsb-validation-error-msg [fc]="addAlphaSenderForm.get('filesUpload')"></wsb-validation-error-msg>
                  </div>
                </div>
              </div>
              <div style="margin-bottom: 10px;" *ngIf="!itsIta">
                <div class="text-info small" [innerHTML]="'sis_service_accept_terms' | translate"></div>
              </div>
              <div class="form-group row" *ngIf="!senderToEdit">
                <div class="col-sm-12">
                  <div class="d-flex align-items-center me-3">
                    <wsb-ui-checkbox [checked]="addAlphaSenderForm.get('authorize').value" [checkboxId]="'authorize'"
                      class="me-1 pt-1" formControlName="authorize"></wsb-ui-checkbox>
                    <label for="authorize" class="ms-2 mt-2" [innerHTML]="'check_terms' | translate"></label>
                  </div>
                  <wsb-validation-error-msg class="d-block mt-2"
                    [fc]="addAlphaSenderForm.get('authorize')"></wsb-validation-error-msg>
                </div>
              </div>
            </form>
          </div>
        </wsb-modal>
      </ng-template>
      <ng-template #modalDeleteAlpha let-c="close" let-d="dismiss">
        <wsb-modal (primary)="modalDeleteAlphaForm()" (dismiss)="d()" cancelButtonEnable="true"
          title="{{ 'common_attention' | translate }}" text="{{ 'sender_delete_confirm' | translate }}"></wsb-modal>
      </ng-template>
      <span class="text-muted" *ngIf="displayHelpTitle()"
        [innerHTML]="'help_arubabusiness_senderregistration' | translate"></span>
      <wsb-atlas-button *ngIf="canRegisterSender" class="my-3" [label]="'sender_new'"
        (click)="openmodalAddEditAlpha()">{{
        'sender_new' | translate
        }}</wsb-atlas-button>
      <div class="my-5">
        <wsb-atlas-grid #alphaGrid *ngIf="tableSendersAlphaColumnDefs && tableSendersAlphaGridOptions"
          class="atlas-grid-simplest mt-2 senders-alpha-grid" [loading]="tableSendersAlphaLoading"
          [columnDefs]="tableSendersAlphaColumnDefs" [options]="tableSendersAlphaGridOptions"
          [@gridIsLoaded]="gridAnimationStateAlpha" [components]="components"></wsb-atlas-grid>
      </div>
    </ng-container>
    <ng-container *ngIf="itsIta">
      <ng-template #modalAddNumeric let-c="close" let-d="dismiss">
        <wsb-modal (primary)="modalAddNumericForm()" cancelButtonEnable="true"
          [primaryDisabled]="inputPhone.phoneNumber.invalid || addNumericSenderForm.invalid"
          primaryButtonText="{{ 'senders_new_ok' | translate }}" (dismiss)="d()" title="{{ 'sender_new' | translate }}">
          <div body>
            <form [formGroup]="addNumericSenderForm">
              <wsb-atlas-inputphone name="number" label="{{ 'sender_numeric_number' | translate }}"
                [labelCssClass]="'me-2'" [cssClass]="'form-control'" #inputPhone
                [formControlName]="'number'"></wsb-atlas-inputphone>
              <wsb-validation-error-msg [fc]="inputPhone.phoneNumber"></wsb-validation-error-msg>
            </form>
          </div>
        </wsb-modal>
      </ng-template>
      <ng-template #modalDeleteNumeric let-c="close" let-d="dismiss">
        <wsb-modal (primary)="modalDeleteNumericForm()" (dismiss)="d()" cancelButtonEnable="true"
          title="{{ 'common_attention' | translate }}" text="{{ 'sender_delete_confirm' | translate }}"></wsb-modal>
      </ng-template>
      <h1 class="page__title h2 mb-5">{{ 'sender_numeric' | translate }}</h1>
      <div *ngIf="displayNumericSender()" [innerHtml]="alertNumericMessage" class="alert-message-numeric" translate>
      </div>

      <wsb-atlas-button *ngIf="displayNumericBtn()" class="my-3" [label]="'sender_new'"
        (click)="openModalAddNumeric()">{{
        'sender_new' | translate
        }}</wsb-atlas-button>
      <div class="my-5">
        <wsb-atlas-grid #numericGrid *ngIf="tableSendersNumericGridOptions" class="atlas-grid-simplest mt-2"
          [loading]="tableSendersNumericLoading" [columnDefs]="tableSendersNumericColumnDefs"
          [options]="tableSendersNumericGridOptions" [@gridIsLoaded]="gridAnimationStateNumeric"
          [components]="components"></wsb-atlas-grid>
      </div>
    </ng-container>
  </div>
</div>